import Device from '../Device'

export default class Container {
  /**
     * Instantiates a new container system which is responsible for
     * detecting ad slot locations and rendering them accordingly
     * @param type ContainerType
     * @param parentIsTarget
     */
  /* eslint-disable */
  constructor (type, parentIsTarget = true) {
    this._type = type
    this._parentIsTarget = parentIsTarget
  }

  /**
   * Override if any criteria may disqualify this container from
   * bring eligible to show, e.g. device size
   * @returns {boolean}
   */
  supported () {
    return true
  }

  type () {
    return this._type
  }

  /**
   * Returns true if we attach the ad unit container to the target selector,
   * for example targeting a div on the page. False if ad unit container should
   * be attached to the document body
   */
  parentIsTarget () {
    return this._parentIsTarget
  }

  /**
   * Return an array of [width, height] defining uppper bounds
   * on max creative size eligible to serve by this container
   * into any given slot.
   * Defaults to window viewport dimensions
   * @returns {Array} Width, Height
   */
  maxSlotDims (slots) {
    return [ Device.width(), Device.height() ]
  }

  /**
     * This method should detect available ad units and return a list of
     * AdSlot classes. If config does not specify, then one single in-place
     * unit should be returned
     */
  adUnits (config) {
    throw Error('Base class called, use an impl instead')
  }

  /**
     * Method should style the given ad(s). These should only receive the winning
     * bids
     * @param slot
     * @param media
     */
  style (bid, slot, media) {
    throw Error('Base class called, use an impl instead')
  }
}
